export type Language =
  | 'markup'
  | 'html'
  | 'css'
  | 'clike'
  | 'javascript'
  | 'abap'
  | 'actionscript'
  | 'ada'
  | 'apacheconf'
  | 'apl'
  | 'applescript'
  | 'arduino'
  | 'arff'
  | 'asciidoc'
  | 'asm6502'
  | 'aspnet'
  | 'autohotkey'
  | 'autoit'
  | 'bash'
  | 'basic'
  | 'batch'
  | 'bison'
  | 'brainfuck'
  | 'bro'
  | 'c'
  | 'csharp'
  | 'cpp'
  | 'coffeescript'
  | 'clojure'
  | 'crystal'
  | 'csp'
  | 'css-extras'
  | 'd'
  | 'dart'
  | 'diff'
  | 'django'
  | 'docker'
  | 'eiffel'
  | 'elixir'
  | 'elm'
  | 'erb'
  | 'erlang'
  | 'fsharp'
  | 'flow'
  | 'fortran'
  | 'gedcom'
  | 'gherkin'
  | 'git'
  | 'glsl'
  | 'go'
  | 'graphql'
  | 'groovy'
  | 'haml'
  | 'handlebars'
  | 'haskell'
  | 'haxe'
  | 'http'
  | 'hpkp'
  | 'hsts'
  | 'ichigojam'
  | 'icon'
  | 'inform7'
  | 'ini'
  | 'io'
  | 'j'
  | 'java'
  | 'jolie'
  | 'json'
  | 'jsx'
  | 'julia'
  | 'keyman'
  | 'kotlin'
  | 'latex'
  | 'less'
  | 'lilypond'
  | 'liquid'
  | 'lisp'
  | 'livescript'
  | 'lolcode'
  | 'lua'
  | 'makefile'
  | 'markdown'
  | 'markup-templating'
  | 'matlab'
  | 'mel'
  | 'mizar'
  | 'monkey'
  | 'n4js'
  | 'nasm'
  | 'nginx'
  | 'nim'
  | 'nix'
  | 'nsis'
  | 'objectivec'
  | 'ocaml'
  | 'opencl'
  | 'oz'
  | 'parigp'
  | 'parser'
  | 'pascal'
  | 'perl'
  | 'php'
  | 'php-extras'
  | 'plsql'
  | 'powershell'
  | 'processing'
  | 'prolog'
  | 'properties'
  | 'protobuf'
  | 'pug'
  | 'puppet'
  | 'pure'
  | 'python'
  | 'q'
  | 'qore'
  | 'r';
